module.exports = __webpack_public_path__ + "media/fun/fun-9-2a27976d.jpg";